import React from 'react';
import image from '../images/gt.png';
import style from '../css/Component2.module.css';
import useLocation from './useLocation';

function Six() {

		const location = useLocation();  

	return (
		<div className={style.container}>
			<img src={image} alt="" className={style.image} />

			<div className={style.box}>
				<h1 className={style.header}>
					Trusted Appliance Repair in {location}
				</h1>
				<p className={style.desc}>
					We specialize in repairing washing machines, refrigerators, air
					conditioners, TVs, and more. If you're looking for fast and reliable
					home appliance repair in Bangalore or Dhanbad, we've got you covered.
				</p>
			</div>
		</div>
	);
}

export default Six;
